export const Acciones = () => {
    return {
        ADD: 'TXT_AGREGAR',
        EDIT: 'TXT_EDITAR',
        DEL: 'TXT_BORRAR',
        SEE: 'TXT_VER',
        REAC: 'TXT_REACTIVAR'
    };
};